<template>
  <div v-if="client.id" class="container-fluid">
    <div class="row">
      <div class="nav-wrapper position-relative end-0">
        <ul class="nav nav-pills nav-fill p-1" role="tablist">
          <li class="nav-item">
            <p
              @click="selectedTab = 'details'"
              class="nav-link mb-0 px-0 py-1"
              :class="{ active: selectedTab == 'details' }"
            >
              Details
            </p>
          </li>
          <li class="nav-item">
            <p
              @click="selectedTab = 'address'"
              class="nav-link mb-0 px-0 py-1"
              :class="{ active: selectedTab == 'address' }"
            >
              Address
            </p>
          </li>

          <li class="nav-item">
            <p
              @click="selectedTab = 'orders'"
              class="nav-link mb-0 px-0 py-1"
              :class="{ active: selectedTab == 'orders' }"
            >
              Orders
            </p>
          </li>
          <li class="nav-item">
            <p
              @click="selectedTab = 'store'"
              class="nav-link mb-0 px-0 py-1"
              :class="{ active: selectedTab == 'store' }"
            >
              Stores
            </p>
          </li>

          <li class="nav-item">
            <p
              @click="selectedTab = 'documents'"
              class="nav-link mb-0 px-0 py-1"
              :class="{ active: selectedTab == 'documents' }"
            >
              Documents
            </p>
          </li>

          <li class="nav-item">
            <p
              @click="selectedTab = 'performance'"
              class="nav-link mb-0 px-0 py-1"
              :class="{ active: selectedTab == 'performance' }"
            >
              Performance
            </p>
          </li>
        </ul>
      </div>
      <div class="col-lg-12 tab-content">
        <div v-if="selectedTab == 'details'" class="card mb-4">
          <display-info
            @save-changes="$emit('save-changes')"
            @update-info="$emit('update-info', $event, 'info')"
            :client="client"
          ></display-info>
        </div>
        <div v-if="selectedTab == 'address'" class="card mb-4">
          <display-address
            @save-changes="$emit('save-changes')"
            @update-info="$emit('update-info', $event, 'address')"
            :client="client"
          ></display-address>
        </div>

        <div v-if="selectedTab == 'orders'" class="card">
          <hr class="horizontal dark mt-4 mb-4" />
          <order-table :client="client" />
        </div>
        <div v-if="selectedTab == 'store'" class="card">
          <store-table :client="client" />
        </div>
        <div v-if="selectedTab == 'documents'" class="card">
          <documents :client="client"></documents>
        </div>
        <div v-if="selectedTab == 'performance'" class="card">
          <ClientOverview :client="client"></ClientOverview>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SoftButton from "@/components/SoftButton.vue";
import SoftAvatar from "@/components/SoftAvatar.vue";
import SoftBadge from "@/components/SoftBadge.vue";
import StoreTable from "./StoreTable.vue";
import OrderTable from "./OrderTable.vue";
import DisplayInfo from "./components/DisplayInfo.vue";
import DisplayAddress from "./components/DisplayAddress.vue";
import Documents from "./components/Documents.vue";
import ClientOverview from "../ecommerce/Orders/ClientOverview.vue";

export default {
  name: "ClientDetails",
  components: {
    SoftButton,
    SoftAvatar,
    SoftBadge,
    StoreTable,
    OrderTable,
    DisplayInfo,
    DisplayAddress,
    Documents,
    ClientOverview
  },
  props: {
    client: {
      type: Object,
      default() {
        return Object;
      },
    },
  },
  emits: ["save-changes", "update-info"],
  data() {
    return {
      selectedTab: "details",
      stores: [],
      orders: [],
      collections: [],
    };
  },
};
</script>
<style scoped>
.nav-item {
  cursor: pointer;
}

.nav-item:last-child {
  cursor: pointer;
  border-right: none;
}

.active {
  background-color: rgba(23, 129, 69, 0.955) !important;
  color: white !important;
}
</style>
